import React, { Component } from 'react';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';

class UploadFileList extends Component {
  handleDelete = index => () => {
    const { deleteFile } = this.props;
    deleteFile(index);
  };

  renderFile = (item, index) => {
    const { isDeleteAvailable = true } = this.props;
    return (
      <div key={index} className="doc-link">
        <div className="doc-icon">
          <Icons icon="file-text-fill" />
        </div>
        <div className="doc-data">
          <div className="doc-name">
            {item.name}
          </div>
        </div>
        <div className="doc-buttons ms-1">
          {isDeleteAvailable ? <div className="doc-button-wrapper" onClick={this.handleDelete(index)}><Icons icon="trash" className="doc-download doc-link-button file-icons" /></div> : null}
        </div>
      </div>
    );
  };

  renderSmallFile = (item, index) => {
    const { isDeleteAvailable = true } = this.props;
    return (
      <div key={index} className="small-link">
        <TooltipWithPortal
          tooltipContent={item.name}
          content={<Icons icon="file-text-fill" className="small-link-file-icon" />}
        />
        {isDeleteAvailable
          ? (
            <div className="doc-delete-button" onClick={this.handleDelete(index)}>
              <Icons icon="trash" className="doc-download doc-link-button file-icons" />
            </div>
          ) : null}
      </div>
    );
  };

  render() {
    const {
      className,
      list,
      smallFiles,
    } = this.props;
    return (
      <div className={classNames('docs-list', className)}>
        {list.map(smallFiles ? this.renderSmallFile : this.renderFile)}
      </div>
    );
  }
}

export default compose(
  injectIntl,
)(UploadFileList);
